
import React, { Component } from "react";
import { translations } from "../../../translate.js";
import {
    UncontrolledDropdown,
    Row,
    Col,
    Card,
    CardBody,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Modal,
    ModalBody,
} from "reactstrap";
import { Button, Drawer } from "@material-ui/core";
import { confirmAlert } from "react-confirm-alert";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Pagination from "react-js-pagination";
import { Picky } from "react-picky";
import "react-picky/dist/picky.css";
import SearchIcon from "@material-ui/icons/Search";
import { toAbsoluteUrl } from "../../../_metronic/index.js";
import { CircularProgress } from "@material-ui/core";
import Switch from "@material-ui/core/Switch";

let Strings =
    localStorage.getItem("LANG") == 1 ? translations.Ar : translations.En;
let today = new Date();
let currentDate =
    today.getFullYear() +
    "-" +
    ("0" + (today.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + today.getDate()).slice(-2);

export default class eFAWATEERcomRecordCategories extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: 0,
            loadingSave: 0,
            limit: 15,
            activePage: 1,
            dataCount: 0,
            searchKey: "",
            errorMsg: "",
            date: [],
            selectedDate: null,

            data: [],
            distributorList: [],
            distId: [],
            subervisorId: [],
            posId: [],

            debitDateFrom: currentDate,
            debitDateTo: currentDate,
            lastPayDateFrom: currentDate,
            lastPayDateTo: currentDate,
            openleftModal: false,
            modal: false,
            posCode: "",
            posCodeError: "",
            modalData: null,
            serialNumber: "",
            selectedMangerPos: [],
            mangerPos: [],
        };
    }


    handleInputChange = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.type === "checkbox" ? target.checked : target.value;
        this.setState(
            {
                [name]: value,
                activePage: 1,
            },
            function () {
                if (name == "filterMode") {
                    this.handleRefresh();
                }
            }
        );
    };

    errorModal = (msg) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="custom-ui alert-box-view">
                        <div className="mb-3">
                            <span className="alert-delete-icon">!</span>
                        </div>
                        <h5>{msg}</h5>
                        <button
                            type="button"
                            className="btn form-cancel-btn alert-btn-margin ml-2 mr-2"
                            onClick={onClose}
                        >
                            {Strings.Cancel}
                        </button>
                    </div>
                );
            },
        });
    };
    confirmBill2 = (event, id) => {
        event.preventDefault();
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="custom-ui alert-box-view">
                        <div className="mb-3">
                            <span className="alert-Succsess-icon">!</span>
                        </div>
                        <h5>{Strings["Are you sure ?"]}</h5>
                        <p>{Strings["You want to confirm this ?"]}</p>
                        <button
                            type="button"
                            className="btn form-cancel-btn alert-btn-margin ml-2 mr-2"
                            onClick={onClose}
                        >
                            {Strings.Cancel}
                        </button>
                        <button
                            type="button"
                            className="btn form-save-btn"
                            onClick={() => {
                                this.confirmBillHandler2(id);
                                onClose();
                            }}
                        >
                            {Strings.Yes}
                        </button>
                    </div>
                );
            },
        });
    };

    handleRefresh = () => {
        this.setState({
            searchKey: "",
            activePage: 1,
            selectedDate: null
        }, function () {
            this.getData();
            this.getDate();
        });
    };


    handleSearch = async () => {
        try {
            this.setState({ loading: 1 });
            const body = {
                type: "getEfwatercomNewApiCategoriesVersion",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
                page: this.state.activePage,
                limit: this.state.limit,
                code: this.state.searchKey,
                date: this.state.selectedDate.entryDate,
            };

            const response = await fetch(window.API_PERM_USER, {
                method: "POST",
                body: JSON.stringify(body),
                headers: {
                    Accept: "application/json",
                },
            });

            const data = await response.json();

            if (data !== "Nothing found") {
                if (data.logout === 1) {
                    localStorage.setItem("USER_ID", "");
                    localStorage.setItem("USER_TOKEN", "");
                    window.location.href = "/logout";
                } else {
                    this.setState({
                        loading: 0,
                        data: data.efwatercomList,
                        dataCount: data?.count
                    });
                }
            } else {
                this.setState({
                    loading: 0,
                    data: [],
                    dataCount: 0
                });
            }
        } catch (error) {
            console.log(error);
            this.setState({ loading: 0 });
        }
        finally {
            this.setState({ loading: 0, loadingSave: 0 });
        }

    };

    componentDidMount() {
        // this.handleSearch();
        this.getData();
        this.getDate();
    }

    getData = async () => {
        try {
            this.setState({ loading: 1 });
            const body = {
                type: "getEfwatercomNewApiCategoriesVersion",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
                page: this.state.activePage,
                limit: this.state.limit
            };

            const response = await fetch(window.API_PERM_USER, {
                method: "POST",
                body: JSON.stringify(body),
                headers: {
                    Accept: "application/json",
                },
            });

            const data = await response.json();

            if (data !== "Nothing found") {
                if (data.logout === 1) {
                    localStorage.setItem("USER_ID", "");
                    localStorage.setItem("USER_TOKEN", "");
                    window.location.href = "/logout";
                } else {
                    this.setState({
                        loading: 0,
                        data: data.efwatercomList,
                        dataCount: data?.count
                    });
                }
            } else {
                this.setState({
                    loading: 0,
                    data: [],
                    dataCount: 0
                });
            }
        } catch (error) {
            console.log(error);
            this.setState({ loading: 0 });
        }
        finally {
            this.setState({ loading: 0, loadingSave: 0 });
        }
    }

    handlePageChange = (pageNumber) => {
        this.setState({ activePage: pageNumber }, function () {
            if (this.state.searchKey) {
                this.handleSearch();
            } else {
                this.getData();
            }
        });
    };
    getDate = async () => {
        try {
            const body = {
                type: "getEfwatercomCategoriesVersionDates",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
            };
            const response = await fetch(window.API_PERM_USER, {
                method: "POST",
                body: JSON.stringify(body),
                headers: {
                    Accept: "application/json",
                },
            });
            const data = await response.json();
            if (data.logout === 1) {
                localStorage.setItem("USER_ID", "");
                localStorage.setItem("USER_TOKEN", "");
                window.location.href = "/logout";
            } else {
                this.setState({ date: data.dates });
            }
        } catch (error) {
            console.log(error);
        }
    }
    handleChangeStatus = async (event, field, id) => {
        this.setState({ loading: 1 });
        try {

            const body = {
                type: "activateEfwatercomCategories",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
                id: id,
                status: event.target.checked ? 1 : 0
            };

            const response = await fetch(window.API_PERM_USER, {
                method: "POST",
                body: JSON.stringify(body),
                headers: {
                    Accept: "application/json",
                },
            });

            const data = await response.json();

            if (data.logout === 1) {
                localStorage.setItem("USER_ID", "");
                localStorage.setItem("USER_TOKEN", "");
                window.location.href = "/logout";
            } else {
                this.getData();
                this.setState({ loading: 0 });
            }

        } catch (error) {
            console.log(error);
            this.setState({ loading: 0 });
        }
    };


    render() {
        return (
            <div>

                <Row>
                    <Col lg={12} className="main-color-1 inv-class-view-title mb-4">
                        <div>

                            {Strings["E-fawatercom Record Categories"]}

                        </div>
                        <hr className="inv-hr-view-2" />
                    </Col>
                </Row>
                <Row className="page-filter-view">
                    <Col
                        xl={{ size: 9, order: 1 }}
                        lg={{ size: 9, order: 1 }}
                        md={{ size: 9, order: 1 }}
                        sm={{ size: 12, order: 1 }}
                        xs={{ size: 12, order: 1 }}
                    >
                        <AvForm ref={(c) => (this.form = c)} className="d-flex flex-column gap-3">
                            <Row>
                                <Col sm={5} xs={12} md={5} lg={5}>
                                    <AvField
                                        name="searchKey"
                                        type="text"
                                        placeholder={Strings["Search"]}
                                        value={this.state.searchKey}
                                        onChange={(event) => {
                                            this.setState({ searchKey: event.target.value });
                                        }}
                                    />

                                </Col>
                                <Col sm={5} xs={12} md={5} lg={5} className="mt-0">
                                    <Picky
                                        value={this.state.selectedDate || null}
                                        options={this.state.date}
                                        onChange={(value) => {
                                            this.setState({ selectedDate: value });
                                        }}
                                        open={false}
                                        valueKey="entryDate"
                                        labelKey="entryDate"
                                        multiple={false}
                                        includeSelectAll={false}
                                        includeFilter={true}
                                        dropdownHeight={200}
                                        placeholder={Strings["Date"]}
                                        filterPlaceholder={Strings["Date"]}
                                    // className="form-control"
                                    />
                                </Col>
                                <Col sm={2} xs={12} md={2} lg={2} className="mt-0">
                                    <button
                                        variant="contained"
                                        className="btn form-save-btn mt-0"
                                        onClick={(event) =>
                                            this.handleSearch()
                                        }
                                    >
                                        {Strings["Search"]}{" "}
                                        <SearchIcon className="font-size-15  main-color-2" />
                                    </button>
                                </Col>

                            </Row>
                        </AvForm>
                    </Col>

                    <Col
                        xl={{ size: 3, order: 12 }}
                        lg={{ size: 3, order: 12 }}
                        md={{ size: 3, order: 12 }}
                        sm={{ size: 12, order: 12 }}
                        xs={{ size: 12, order: 12 }}
                        className="text-right mb-3  d-flex flex-column align-items-end gap-3 w-100"
                    >


                        {/* <Col sm={12} xs={12} md={10} lg={10}>
                            <button
                                className="btn gradient-button-view gradient-button gradient-button-font-12 m-1 w-100"
                                onClick={
                                    () => this.handleRefreshAllCard()
                                }
                            >
                                {Strings["Update e-fawatercom Cards"]}
                            </button>

                            <button
                                value={this.state.allCkecked == 0 ? "0" : "1"}
                                className="btn page-action-btn m-1 mt-2 w-100"
                                onClick={() => this.handleUpdateAllCard()}
                            >

                                {Strings["Enable POS Cards"]}
                            </button>
                        </Col> */}
                        <Col sm={12} xs={12} md={5} lg={5}>
                            <Button
                                variant="contained"
                                className="refresh-action-btn"
                                onClick={this.handleRefresh}
                                title={Strings["Refresh"]}
                                style={{ marginTop: "10px" }}
                            >
                                <i className="flaticon-refresh reset-filter-btn"></i>
                            </Button>
                        </Col>

                    </Col>
                </Row>
                {this.state.loading == 0 && this.state.errorMsg != "" && (
                    <Row>
                        <div className="inv-cards-view pb-5 width-100">
                            <div
                                className="text-center"
                                style={{ marginTop: "15%", marginBottom: "15%" }}
                            >
                                <img
                                    alt="Logo"
                                    src={toAbsoluteUrl(
                                        "/media/ezpay/EZPAY_LOGO_GRAY" + window.MAIN_IMAGE + ".png"
                                    )}
                                    className="img-fluid no-data-img"
                                />
                                <div className="no-data-text">{this.state.errorMsg}</div>
                            </div>
                        </div>
                    </Row>
                )}
                {this.state.loading == 0 &&
                    this.state.data.length <= 0 &&
                    this.state.errorMsg == "" && (
                        <Row>
                            <div className="inv-cards-view pb-5 width-100">
                                <div
                                    className="text-center"
                                    style={{ marginTop: "15%", marginBottom: "15%" }}
                                >
                                    <img
                                        alt="Logo"
                                        src={toAbsoluteUrl(
                                            "/media/ezpay/EZPAY_LOGO_GRAY" +
                                            window.MAIN_IMAGE +
                                            ".png"
                                        )}
                                        className="img-fluid no-data-img"
                                    />
                                    <div className="no-data-text">
                                        {Strings["There is no data to display"]}
                                    </div>
                                </div>
                            </div>
                        </Row>
                    )}
                {this.state.loading == 1 && (
                    <Row>
                        <Col lg={12} style={{ marginTop: "7%" }} className="text-center">
                            <div className="card-body">
                                <div
                                    className="spinner-grow text-dark m-2 main-color-1"
                                    role="status"
                                ></div>
                                <div
                                    className="spinner-grow text-dark m-2 main-color-2"
                                    role="status"
                                ></div>
                                <div
                                    className="spinner-grow text-dark m-2 main-color-1"
                                    role="status"
                                ></div>
                                <div
                                    className="spinner-grow text-dark m-2 main-color-2"
                                    role="status"
                                ></div>
                                <div
                                    className="spinner-grow text-dark m-2 main-color-1"
                                    role="status"
                                ></div>
                                <div
                                    className="spinner-grow text-dark m-2 main-color-2"
                                    role="status"
                                ></div>
                            </div>
                        </Col>
                    </Row>
                )}
                {this.state.loading == 0 && this.state.data.length > 0 && (
                    <Row>
                        <div className="inv-cards-view width-100">
                            <Row className="table-header-row d-none d-lg-flex d-md-flex">
                                <Col
                                    lg={2}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="overflow-text-length"
                                    title={Strings["Point name"]}
                                >
                                    {Strings["ID"]}
                                </Col>
                                <Col
                                    lg={3}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="overflow-text-length"
                                    title={Strings["Total withdrawn profits"]}
                                >
                                    {Strings["Code"]}
                                </Col>
                                <Col
                                    lg={3}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="overflow-text-length"
                                    title={Strings["Class Name"]}
                                >
                                    {Strings["Class Name"]}
                                </Col>
                                <Col
                                    lg={2}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="overflow-text-length"
                                    title={Strings["Date"]}
                                >
                                    {Strings["Date"]}
                                </Col>
                                <Col
                                    lg={2}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="overflow-text-length"
                                    title={Strings["Status"]}
                                >
                                    {Strings["Status"]}
                                </Col>



                            </Row>
                            {this.state.data.map((rowData, index) => {
                                return (
                                    <Row key={index} className="table-body-row">
                                        <Col
                                            lg={2}
                                            md={12}
                                            sm={3}
                                            xs={12}
                                            className="overflow-text-length  order-2 order-md-1 order-lg-1 "
                                            title={Strings["POS Name"]}
                                        >

                                            {rowData.id}
                                        </Col>
                                        <Col
                                            lg={3}
                                            md={12}
                                            sm={3}
                                            xs={12}
                                            className="overflow-text-length order-3 order-md-2 order-lg-2"
                                            title={Strings["Total withdrawn profits"]}
                                        >

                                            {rowData.code}
                                        </Col>
                                        <Col
                                            lg={3}
                                            md={12}
                                            sm={3}
                                            xs={12}
                                            className="overflow-text-length order-1 order-md-3 order-lg-3 text-bold-ssm"
                                            title={Strings["Total unwithdrawn profits"]}
                                        >

                                            {rowData.catName}
                                        </Col>
                                        <Col
                                            lg={2}
                                            md={12}
                                            sm={3}
                                            xs={12}
                                            className="overflow-text-length order-4 order-md-4 order-lg-4 "
                                        >
                                            {rowData.entryDate}
                                        </Col>
                                        <Col
                                            lg={2}
                                            md={12}
                                            sm={3}
                                            xs={12}
                                            className="overflow-text-length order-4 order-md-4 order-lg-4 "
                                        >
                                            <div className="">

                                                <Switch
                                                    checked={rowData["status"] == 1 ? true : false}
                                                    onChange={(event) =>
                                                        this.handleChangeStatus(
                                                            event,
                                                            "status",
                                                            rowData["id"]
                                                        )
                                                    }
                                                    name="status"
                                                    inputProps={{ "aria-label": "secondary checkbox" }}
                                                    size={"small"}
                                                    disabled={true}
                                                />
                                            </div>
                                        </Col>

                                    </Row>
                                );
                            })}
                            {this.state.loading == 0 && this.state.data?.length > 1 && (
                                <Col md={12}>
                                    <Row className="pagenation-view mt-3 mb-4">
                                        <Pagination
                                            activePage={this.state.activePage}
                                            itemsCountPerPage={this.state.limit}
                                            totalItemsCount={this.state.dataCount}
                                            pageRangeDisplayed={4}
                                            onChange={this.handlePageChange}
                                            prevPageText={
                                                <i
                                                    className={
                                                        localStorage.getItem("LANG") == 1
                                                            ? "flaticon2-next"
                                                            : "flaticon2-back"
                                                    }
                                                ></i>
                                            }
                                            nextPageText={
                                                <i
                                                    className={
                                                        localStorage.getItem("LANG") == 1
                                                            ? "flaticon2-back"
                                                            : "flaticon2-next"
                                                    }
                                                ></i>
                                            }
                                            hideFirstLastPages
                                            innerClass={
                                                "pagination  pagination-rounded justify-content-end pagenation-view my-2"
                                            }
                                            itemClass={"page-item"}
                                            linkClass={"page-link"}
                                        />
                                    </Row>
                                </Col>
                            )}
                        </div>
                    </Row>
                )}

                <Drawer
                    anchor={localStorage.getItem("LANG") == 1 ? "left" : "right"}
                    open={this.state.openleftModal}
                    className={
                        this.state.actionType == "notification"
                            ? "sidebar-modal-large-view"
                            : "sidebar-modal-view"
                    }
                >
                    {/* {this.state.openleftModal && (
                        <AddBillForm
                            getSupervisorBalance={this.props.getSupervisorBalance}
                            balance={this.props.balance}
                            billTypes={this.state.billTypes}
                            posList={this.state.posList}
                            close={this.closeSidebarModal}
                        />
                    )} */}
                </Drawer>
                <Drawer
                    anchor={localStorage.getItem("LANG") == 1 ? "left" : "right"}
                    open={this.state.openModal}
                    className={"sidebar-modal-large-view"}
                >
                    {/* {this.state.openModal && (
                        <BillDetails
                            {...this.state.modalData}
                            close={this.closeSidebarModal2}
                        />
                    )} */}
                </Drawer>
            </div>
        );
    }
}
